// src/components/HeroSlider.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

export default function HeroSlider({ products = [] }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Convertimos products → slides
  const slides = useMemo(
    () =>
      products.map((p) => ({
        id: p.id,
        image: isMobile ? p.imageHeroHomeMobile : p.imageHeroHomeDesktop,
        title: p.name,
        subtitle: p.subtitle,
        link: p.link || `/product/${p.id}`,
        showTextOverlay: true,
        isFullImage: true,
        textColor: p.textColor,
        buttonText: p.buttonText
      })),
    [products, isMobile]
  );

  if (!slides.length) return null;

  return (
    <section className="relative w-full mt-[35px]">
      <Swiper
        navigation={{
          enabled: true,
          hideOnClick: false,
        }}
        allowTouchMove={true}
        modules={[Navigation, Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        loop={true}
        className="w-full h-[73vh] md:h-[80vh] relative z-[30]"  
      >

        {slides.map((s) => (
          <SwiperSlide key={s.id}>
            <div className="relative w-full h-[73vh] md:h-[80vh]">

              {/* Imagen */}
              <Link to={s.link}>
              <img
                src={s.image}
                alt={s.title}
                className="w-full h-full object-cover"
                loading="eager"
              />
              </Link>
              {/* Overlay oscuro (ya no tapa flechas) */}
              {s.showTextOverlay && (
                <div className="absolute inset-0 bg-transparent flex items-end justify-center z-[10] pb-10 pointer-events-none">

                <div
                  className="text-center max-w-2xl px-6 animate-fadeSlideIn pointer-events-auto"
                  style={{ color: s.textColor || "#ffffff"}}
                >
                 <h1 className="text-3xl md:text-5xl font-extrabold leading-tight drop-shadow-lg">
                  {s.title}
                </h1>

                <p
                  className="mt-3 text-base md:text-lg text-white/90 font-medium drop-shadow"
                  style={{ color: s.textColor || "#ffffff", visibility: s.subtitle ? "visible" : "hidden" }}
                >
                  {s.subtitle || "placeholder"}
                </p>
                  {s.buttonText && (
                  <div className="mt-5 flex justify-center">
                    <Link
                      to={s.link}
                      className="inline-flex items-center justify-center
                                bg-white font-bold
                                px-6 py-3 rounded-xl shadow-lg transition text-black"
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = s.textColor || "#f4d27a";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white";
                      }}
                    >
                      {s.buttonText}
                    </Link>

                  </div>
                   )}
                </div>

              </div>
              )}
            </div>
          </SwiperSlide>
        ))}

      </Swiper>

      {/* Estilos finos para dots y flechas */}
      <style>{`
  /* Dots */
  .swiper-pagination {
    z-index: 9999 !important;
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: #fff;
    opacity: .4;
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
    background: #e45f5a;
  }

  /* FLECHAS – FIX DEFINITIVO */
  .swiper-button-next,
  .swiper-button-prev {
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%);
    z-index: 999999 !important;
    width: 45px !important;      /* << hitbox más grande */
    height: 45px !important;
    display: flex !important;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.35); /* burbuja elegante */
    border-radius: 50%;
    backdrop-filter: blur(4px);
    color: white !important;
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    font-size: 22px !important;
    font-weight: bold !important;
  }

  /* FORZAR VISIBILIDAD EN MÓVIL */
  @media (max-width: 640px) {
    .swiper-button-next,
    .swiper-button-prev {
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
    }
  }
`}</style>


    </section>
  );
}
